import { ErrorMessageStrategy } from '@shared/utils/interfaces';

export const changeOwnUserStatusStrategy: ErrorMessageStrategy = () => {
  return {
    translationKey: 'errors.CANNOT_CHANGE_USER_STATUS',
  };
};
